import { useCallback, useEffect, useState } from 'react';

import { Checkbox } from '@webapp/common/components/checkbox';
import { Modal } from '@webapp/common/components/modal';
import { KeyType, SessionStorage } from '@webapp/common/lib/storage';
import { nop } from '@webapp/common/lib/utils';

import css from './confirm-remove-popup.css';

export const ConfirmRemovePopup: FC<{
    title: string;
    visible?: boolean;
    type?: string;
    onAccept?: () => void;
    onCancel?: () => void;
    onClose?: () => void;
    onRemove?: () => void;
    onPurge?: () => void;
    acceptText?: string;
    children?: ReactNode;
}> = ({
    acceptText = 'Удалить',
    onAccept,
    onCancel = nop,
    onClose = nop,
    onRemove,
    onPurge,
    title,
    type,
    visible: visibleProp,
    children,
}) => {
    const [visible, setVisible] = useState(visibleProp);
    const [dontAskValue, setDontAskValue] = useState(false);

    useEffect(() => {
        const dontAsk = type && SessionStorage.getWithType(KeyType.DONT_ASK, type);

        if (dontAsk && visibleProp) {
            onAccept && onAccept();
            onClose && onClose();
        } else {
            setVisible(visibleProp);
        }
    }, [visibleProp, type, onAccept, onClose]);

    const handleClickDelete = useCallback(() => {
        type && SessionStorage.setWithType(KeyType.DONT_ASK, type, dontAskValue);
        onAccept && onAccept();
        onPurge && onPurge();
        onClose && onClose();
    }, [dontAskValue, onAccept, onClose, onPurge, type]);

    const handleClickCancel = useCallback(() => {
        onCancel && onCancel();
        onClose && onClose();
    }, [onCancel, onClose]);

    const handleSetDontAsk = useCallback((value: boolean) => {
        setDontAskValue(value);
    }, []);

    return (
        <Modal
            acceptText={acceptText}
            className={css.popup}
            visible={visible}
            onAccept={onAccept && handleClickDelete}
            onCancel={handleClickCancel}
            onClose={onClose}
            onPurge={onPurge && handleClickDelete}
            onRemove={onRemove && handleClickDelete}
        >
            <div className={css.content}>
                <div className={css.title}>{title}</div>
                {type && (
                    <div className={css.dontAsk}>
                        <Checkbox label='Не спрашивать' onChange={handleSetDontAsk} />
                    </div>
                )}
                {children && <div>{children}</div>}
            </div>
        </Modal>
    );
};
